export default (x) => (x === null || x === void 0 ? void 0 : x.constructor) === Object;
//# sourceMappingURL=isPojo.mjs.map